import { render, staticRenderFns } from "./addQuizz.vue?vue&type=template&id=1752081a&"
import script from "./addQuizz.vue?vue&type=script&lang=js&"
export * from "./addQuizz.vue?vue&type=script&lang=js&"
import style0 from "./addQuizz.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports